// src/hooks/useProjects.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
// import { setProjects, setError, clearProjects } from '../features/projectsSlice';
import { setSingleProject, setError, clearProject } from '../features/singleProject';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';

export const useSingleProject = (projectId) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['singleProjectOver', projectId],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/projects/${projectId}`);
      console.log('Raw API response:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting projects in Redux:', data);
      dispatch(setSingleProject(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setError(error.message));
    },
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};